import get from 'lodash/fp/get'

export const getDeliverableTypes = get('deliverableTypes')

export const getDeliverablesTypesNameById = state => id => {
  const types = getDeliverableTypes(state)
  const type = get(id)(types)
  return get('name')(type)
}
